export default __webpack_public_path__ + "static/8k-6692839c46e3a7a4fafde4183404eb44.jpg";